export enum Step {
  CARD_CHOICE = 'cardChoice',
  CARD_SELECTOR = 'cardSelector',
  SECOND_CARD_SELECTOR = 'secondCardSelector',
  PRODUCT_CHOICE = 'productChoice',
  CONSUMER_SEARCH = 'consumerSearch',
  CONSUMER_SEARCH_START = 'consumerSearchStart',
  // NOTE: Step.APPLICATION is used by all workflows; 'creditApplication' is thus rather too specific, but meh.
  APPLICATION = 'creditApplication',
  APPLICATION_2 = 'creditApplication2',
  ADD_ONS = 'addOns',
  REVIEW_TERMS = 'reviewTerms',

  PRESCREEN_OFFER = 'prescreenOffer',

  DSP_START = 'dspStart',

  BATCH_PRESCREEN_START = 'batchPrescreenStart',

  PREQUAL_OFFER_APPLICATION = 'prequalOfferApplication',
  PREQUAL_OFFER_PUSH_START = 'prequalOfferPushStart',

  MEMBERSHIP_VALIDATION = 'membershipValidation',

  DRIVER_LICENSE_START = 'driverLicenseStart',
  SCAN_PAGE = 'scanPage',

  UNIFIED_CHECKOUT_HOME = 'unifiedCheckoutHome',
  UNIFIED_PREQUAL_HOME = 'unifiedPrequalHome',
  UNIFIED_OFFER_INTRO = 'unifiedOfferIntro',
  UNIFIED_CONSUMER_SEARCH = 'unifiedConsumerSearch',
  UNIFIED_OFFER_APPLICATION = 'unifiedOfferApplication',
  UNIFIED_PREQUAL_OFFER = 'unifiedPrequalOffer',
  UNIFIED_PREQUAL_CHECKOUT_OFFER = 'unifiedPrequalCheckoutOffer',
  UNIFIED_APPLICATION_REVIEW = 'unifiedApplicationReview',
  UNIFIED_PREQUAL_OFFER_PUSH_APPLICATION = 'unifiedPrequalOfferPushApplication',

  MAGIC_LINK_VERIFICATION = 'magicLinkVerification',
  MAGIC_LINK_ACCEPT = 'magicLinkAccept',
}

export interface Workflow {
  /**
   * Keys are steps in the workflow
   * Values are whether that particular step is enabled.
   */
  stepsEnabled: Partial<{ [key in Step]: boolean }>;
  /**
   * Map workflow steps to paths
   */
  paths: Partial<{ [step in Step]: string }>;
  /**
   * The first step in the progress bar
   */
  progressStartStep: Step | null;

  /**
   * The step to go to when restarting the workflow
   */
  restartStep: Step;

  /**
   * The step to go to when the app times out
   */
  timeoutRestartPath: string;
}
